import { IColumnFilter } from "@/types";

type IQueryColumns = string | (string | null)[] | null | undefined;

const getAllColumns = (columns: IColumnFilter[]): IColumnFilter['items'] => {
    return columns.flatMap((i) => i.items);
};

/**
 * Колонки из урла, оставляя только те, что есть у текущей таблицы.
 *
 * Вкладки с разными наборами колонок делят query-параметр columns, поэтому в урле
 * остаются чужие значения: без отсечения таблица получает набор, которого у неё нет,
 * и не показывает ни одной колонки (CRM-5511).
 *
 * null означает, что урл не дал ничего пригодного и брать нужно набор по умолчанию.
 */
export function getColumnsFromQuery(queryColumns: IQueryColumns, columns: IColumnFilter[]): string[] | null {
    if (!queryColumns) return null;

    const availableColumns = getAllColumns(columns).map((i) => i.value);
    const selected = (Array.isArray(queryColumns) ? queryColumns : [queryColumns])
        .filter((i): i is string => !!i && availableColumns.includes(i));

    return selected.length > 0 ? selected : null;
}

/** Набор колонок таблицы по умолчанию: все, кроме помеченных default: false. */
export function getDefaultColumns(columns: IColumnFilter[]): string[] {
    return getAllColumns(columns)
        .filter((i) => i.default !== false)
        .map((i) => i.value);
}
